import { useEffect, useState } from 'react'

import Container from '@/components/atoms/container/container'
import Footer from '@/components/organisms/footer/footer'
import Header from '@/components/organisms/header/header'
import DepositSuccessAnimationTemplate, {
    DepositClaimStatus,
    DepositFlowStatus
} from '@/components/templates/depositSuccessAnimation/depositSuccessAnimationTemplate'
import { useTranslate } from '@/i18n/useTranslate'

export default function DepositAnimationDebugPage() {
    const { t } = useTranslate()
    const [runId, setRunId] = useState(0)
    const [status, setStatus] = useState<DepositFlowStatus>('processing')
    const [failedAttempts, setFailedAttempts] = useState(0)
    const [claimStatus, setClaimStatus] = useState<DepositClaimStatus>('pending')
    const [rewardAmount, setRewardAmount] = useState(0)

    const replaySuccess = () => {
        setStatus('processing')
        setFailedAttempts(0)
        setClaimStatus('pending')
        setRewardAmount(0)
        setRunId((id) => id + 1)
    }

    useEffect(() => {
        if (status !== 'processing') return

        const timer = window.setTimeout(() => {
            setStatus('success')
        }, 4200)

        return () => window.clearTimeout(timer)
    }, [runId, status])

    return (
        <Container isFullHeight={true}>
            <Header
                navigateBackUrl="/welcome-with-services"
                navigationBackText={t('header.back')}
            />
            <div className="payment-in-progress__content deposit-animation-debug">
                <button
                    type="button"
                    className="deposit-animation-debug__fail"
                    onClick={() => {
                        setStatus('failed')
                        setFailedAttempts((count) => Math.max(count, 1))
                    }}>
                    Test error
                </button>
                <DepositSuccessAnimationTemplate
                    key={runId}
                    amount={500}
                    currency="RSD"
                    vendorName="Mozzart"
                    accountId="12345678"
                    status={status}
                    failedAttempts={failedAttempts}
                    claimStatus={claimStatus}
                    claimRewardAmount={rewardAmount}
                    pendingRewardAmount={200}
                    pendingRewardCurrency="RSD"
                    onBaseReady={() => {
                        window.setTimeout(() => {
                            setRewardAmount(200)
                            setClaimStatus('success')
                        }, 3000)
                    }}
                    onRetry={replaySuccess}
                    onComplete={replaySuccess}
                />
            </div>
            <Footer />
        </Container>
    )
}
